<template>
  <article class="confirm-order-modal">
    <h3 class="confirm-order-modal__title">{{ $gettext('Claim assignment') }}</h3>
    <div v-if="modalText"
         class="confirm-order-modal__text"
         v-html="modalText"></div>
    <sk-checkbox :preselected-value="confirmFilePolicy"
                 :item-text="filePolicyText"
                 class="confirm-order-modal__checkbox"
                 @checkboxvaluechanged="setConfirmFilePolicy" />
    <div class="confirm-order-modal__buttons">
      <button class="sk-btn sk-btn--white"
              @click="closeModal">{{ $gettext('Cancel') }}</button>
      <button :disabled="!confirmFilePolicy"
              class="sk-btn sk-btn--primary"
              @click="claimOrder">{{ $gettext('Confirm and claim') }}</button>
    </div>
  </article>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
      return {
        confirmFilePolicy: false
      };
    },
    computed: {
      modalData() {
        return this.data || {};
      },
      modalText() {
        return this.modalData.text || '';
      },
      modalCallback() {
        return this.modalData.modalCallback;
      },
      filePolicyText() { return this.$gettext('I confirm that I will not share any files or content related to this translation assignment.'); }
    },
    watch: {
      $route() {
        this.closeModal();
      }
    },
    methods: {
      closeModal() {
        this.$emit('closemodal');
      },
      claimOrder() {
        this.modalCallback('accepted');
        this.$emit('closemodal');
      },
      setConfirmFilePolicy(value) {
        this.confirmFilePolicy = value;
      }
    }
  };
</script>

<style scoped>
.confirm-order-modal {
  margin: 0 32px 32px;
  color: #333;
}

.confirm-order-modal__title {
  font-size: 20px;
}

.confirm-order-modal__buttons {
  display: flex;
  justify-content: flex-end;
}

.confirm-order-modal__text {
  margin-top: 16px;
}

.confirm-order-modal__checkbox {
  margin: 24px 0;
}

button {
  width: fit-content;
  margin-left: 8px;
  padding: 0 12px;
}
</style>
